import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import { useSelector } from 'react-redux';
import BillingInfo from '../components/HomePageNew/BillingInfo';
import Spinner from 'components/shared/Spinner';

const BillingInfoPageNew = ({ ...props }) => {
  const termsAgreementDetails = useSelector(
    state => state?.termsAndConditions?.termsAgreementDetails
  );
  const isConfigLoaded = Object.keys(termsAgreementDetails || {}).length > 0;

  return (
    <div>
      <HeaderFooterLayout>
        {isConfigLoaded ? <BillingInfo {...props} /> : <Spinner />}
      </HeaderFooterLayout>
    </div>
  );
};

export default BillingInfoPageNew;